import React from "react";
import '../styles/PrivacyPolicy.css'; // Link your CSS file

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>
        In this privacy policy, we, Keto Diets UAB, company code 305493532, registration address Aludariu str. 3. Vilnius, Lithuania
        ("Company", "we", "us" or "our"), explain how we handle your personal data when you visit our website, use our Mobile apps,
        contact us through our official social media pages or email, and/or use our services.
      </p>
      <p>
        Please note that in case you purchase physical goods while using our services, Max Nutrition UAB, company code 305420438,
        with registered office at Herkaus Manto g. 4-133, Vilnius, Lithuania, office address at Antakalnio 17, Vilnius, Lithuania is
        responsible for data processing with regard to this particular service. In such cases "Company", "we", "us" or "our" shall
        refer to Max Nutrition UAB. In case you have any privacy-related inquiries or requests associated to physical goods, you may
        contact us by email: <a href="mailto:hello@dorganicschallenge.com">hello@dorganicschallenge.com</a>.
      </p>

      <p>In this notice you will find the answers to the following questions:</p>
      <ul>
        <li>a. how we use your data;</li>
        <li>b. when we provide your data to others;</li>
        <li>c. how long we store your data;</li>
        <li>d. what is our marketing policy;</li>
        <li>e. what rights related to personal data you possess;</li>
        <li>f. how we use cookies;</li>
        <li>g. other issues that you should take into account.</li>
      </ul>

      <p>
        In case of any inquiries or if you would like to exercise any of your rights provided in this notice, you may submit such
        inquiries and requests by means provided in the Contacts section.
      </p>

      <p>
        You may also contact Data Protection Officer of the Company regarding all privacy-related issues by email:{" "}
        <a href="mailto:hello@dorganicschallenge.com">hello@dorganicschallenge.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
